package com.taocent.simple.compose.component.blockrichtext

private var blockIdCounter = 0L

internal fun generateBlockId(): String {
    return "block_${++blockIdCounter}"
}
